// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 729 ? "4d022aba" : chunkId) + "." + {"313":"e70858fe5a897b2d","425":"b2bffc27f4138e2f","436":"e0d328844150b081","525":"809e089904f27f33","729":"41d22836c1e44131","752":"154ff47e6b046a61","954":"0d7ec814ab32fad8","961":"7c302e444df31794","974":"215eaca349bf2692"}[chunkId] + ".js";
};